import { IonContent, IonIcon, IonPage, IonInput, IonSpinner } from "@ionic/react"
import Head from "../Header"
import Sidebar from "../Sidebar"
import { IonDatetime } from '@ionic/react';
import DataTable from "react-data-table-component";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import service from "../../Service/service";
import swal from 'sweetalert';
import "../../theme/style2.css"
import moment from "moment"
import Select from "react-select"
import { searchOutline, chevronDownOutline } from "ionicons/icons";
import DatePicker from "react-date-picker";


const ClientReport: React.FC = () => {
    const [Id] = useState(localStorage.getItem("SignupEmpId"));

    const [roleuser] = useState(localStorage.getItem("UserRole"));
    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));

    const [id, setid] = useState("")
    const [data, setData] = useState([])
    data.forEach((item: any, index: any) => { item.serial = index + 1; });
    const [isLoading, setIsLoading] = useState(false)

    // ***************Fromdate endDate*********************

    const [fromDate, setFromDate] = useState('');
    const [month, setmonth] = useState('')

    const [projectid, setProjectid] = useState("");
    const [toDate, settoDate] = useState("")
    const [clients, setclients] = useState([])
    const [projectStatusId, setProjectStatusId] = useState("")
    // ***************datatable*********************
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    // ***************client and project*********************

    const [cliname, setcliname] = useState<{ id: string; clientName: string }[]>([]);
    const [projects, setProjects] = useState([])
    const [selectedClientId, setSelectedClientId] = useState('');

    // ***************hide and show for datatable*********************
    const [areCheckboxesSelected, setAreCheckboxesSelected] = useState(false);
    const [isSearchClicked, setIsSearchClicked] = useState(false);

    // ***************Auto complete*********************

    const [safariMonth, setSafariMonth] = useState(null);

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Client</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen1) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen1]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = [

        ...cliname.map((state: any) => ({
            value: state.id,
            label: state.clientName,
        })),

    ];


    const handleclient = (selectedOption: any) => {
        setSelectedClientId(selectedOption.value)
        setid(selectedOption.value)

    };
//.................Project Status Autocomplete........................//

const [selectedOption9, setSelectedOption9] = useState(null);
const [inputValue9, setInputValue9] = useState('');
const [isFocused9, setIsFocused9] = useState(false);
const [menuIsOpen9, setMenuIsOpen9] = useState(false);

const handleStateChange9 = (selectedOption9: any) => {
    setSelectedOption9(selectedOption9);
};

const handleInputChange9 = (inputValue9: any) => {
    setInputValue9(inputValue9);
};

const handleMenuOpen9 = () => {
    setMenuIsOpen9(true);
};

const handleMenuClose9 = () => {
    setMenuIsOpen9(false);
};

const handleFocus9 = () => {
    setIsFocused9(true);
};

const handleBlur9 = () => {
    setIsFocused9(false);
};

const Placeholder9 = () => {
    if (inputValue9 === '' && !selectedOption9 && !isFocused9) {
        return <span style={{ color: "black" }}>Open</span>;
    } else {
        return <span style={{ color: "black" }}>Type to Search Here...</span>;
    }
};

const DropdownIndicator9: any = ({ innerProps, selectProps }: any) => {
    const [isClicked, setIsClicked] = useState(false);

    useEffect(() => {
        if (isClicked && !selectProps.menuIsOpen9) {
            setIsClicked(false);
        }
    }, [selectProps.menuIsOpen9]);

    let icon;
    if (isClicked || selectProps.menuIsOpen) {
        icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
    } else {
        icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
    }

    const handleIconClick = () => {
        setIsClicked(true);
    };

    return (
        <div {...innerProps}>
            <div onClick={handleIconClick}>{icon}</div>
        </div>
    );
};
const options9 = statusList.map((state: any) => ({
    value: state.id,
    label: state.status,
}));

const hanldeStatusTypes = (selectedOption9: any) => {
    setProjectStatusId(selectedOption9.value)
}

    const history = useHistory();
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        }
        Client()
        GetStatusList()
    }, [Id, history]);

    const hanldeStatusType = (e: any) => {
        setProjectStatusId(e.target.value)
    }

    // ******************************** Datatable *******************************
    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px",
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit.businessUnitName,
            sortable: true,

        },
        {
            name: "Department Unit",
            selector: (itm: any) => itm.masterDepartment.departmentName,
            sortable: true,
        },
        {
            name: "Project Name",
            selector: (itm: any) => itm.projectName,
            sortable: true,

        },
        {
            name: "Client Details",
            selector: (itm: any) => itm.client.clientName,
            sortable: true,
        },
        {
            name: "Status",
            // selector: (itm: any) => itm.projectStatus.status,
            sortable: true,
            width: "100px",
            cell: (itm: any) => (
                <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {itm.projectStatus.status === "Open" ? (
                        <p style={{ color: "#00b700", margin: '0' }}>Open</p>
                    ) : itm.projectStatus.status === "Hold" ? (
                        <p style={{ color: "orange", margin: '0' }}>Hold</p>
                    ) : (
                        <p style={{ color: "red", margin: '0' }}>Close</p>
                    )}
                </div>

            )
        }
    ];

    const cli = (e: any) => {
        setSelectedClientId(e.target.value)
        setid(e.target.value)
    }
    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                justifyContent: "center"
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center"
            }
        }
    };

    //******************Search filter***************//

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };
        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);
    // ----------------------Get status list ---------------------

    const GetStatusList = () => {
        service.GetPrjClsStatuslist()
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    setStatusList(response.data);
                }
                else {
                    setStatusList([])
                }
            })
    }

    //*************** Client and Project *********************//

    const Client = () => {
        service.Clientlist(createdBy)
            .then((response) => {
                console.log("API Response:", response);
                if (response.status === 200) {
                    console.log("Response Data:", response.data);
                    setcliname(response.data);
                    const clientNames = response.data.map((client: { clientName: string }) => client.clientName);
                    setclients(clientNames);
                }
                else {
                    setcliname([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching client data:", error);
                setcliname([]);
            });
    };


    const Cliproject = () => {
        if (month.length === 0) {
            swal("", "Please Select Month & Year", "info");
        } else if (id === "") {
            swal("", "Please Select Client", "info");
        } else {
            setIsLoading(true);
            service.Clientproject(id, createdBy, projectStatusId)
                .then((response) => {
                    console.log(response);
                    if (response.status === 200) {
                        setData(response.data);
                        setProjectid(response.data.projectManager);
                        setIsSearchClicked(true);
                    } else {
                        setData([]);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching project data:", error);
                    setData([]);
                })
                .finally(() => {
                  
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 500); 
                });
        }
    }
    const Projectidd = (e: any) => {
        const data = e.selectedRows.map((ee: any) => {
            return ee.id
        })
        console.log(data)
        setProjects(data)
        setAreCheckboxesSelected(data.length > 0)
        setSelectedRows(selectedRows);
    }

    //*****************Pdf Projectwise Api****************//

    const Export = () => {
        setIsLoading(true);
        setTimeout(() => {
            if (!selectedClientId) {
                setIsLoading(false);
                swal("", "No client selected.", "error");
                return;
            }

            if (projects.length === 0) {
                setIsLoading(false);
                swal("", "No projects selected.", "error");
                return;
            }
            const selectedClient = cliname.find(client => client.id === selectedClientId);
            if (!selectedClient) {
                setIsLoading(false);
                console.error("Selected client not found.");

                return;
            }

            const obj = {
                "clientId": id,
                "projectId": projects,
                "fromDate": fromDate,
                "toDate": toDate
            };

            service.Pdfgenerate(obj, selectedClient.clientName, month)
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }, 1000);
    };

    //************************Pdf employee wise******************//

    const PDF = () => {
        setIsLoading(true);
        setTimeout(() => {
            if (!selectedClientId) {
                setIsLoading(false);
                swal("", "No client selected.", "error");
                return;
            }

            if (projects.length === 0) {
                setIsLoading(false);
                swal("", "No projects selected.", "error");
                return;
            }

            const selectedClient = cliname.find(client => client.id === selectedClientId);
            if (!selectedClient) {
                setIsLoading(false);
                console.error("Selected client not found.");
                return;
            }

            const obj = {
                "clientId": id,
                "projectId": projects,
                "fromDate": fromDate,
                "toDate": toDate
            };
            service.EmployeePdfgenerate(obj, selectedClient.clientName, month)
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }, 1500);
    }

    //*****************Excel generate****************//

    const Excel = () => {
        setIsLoading(true);
        setTimeout(() => {
            if (!selectedClientId) {
                setIsLoading(false);
                swal("", "No client selected.", "error");
                return;
            }

            if (projects.length === 0) {
                setIsLoading(false);
                swal("", "No projects selected.", "error");
                return;
            }

            const selectedClient = cliname.find(client => client.id === selectedClientId);
            if (!selectedClient) {
                setIsLoading(false);
                console.error("Selected client not found.");
                return;
            }

            const obj = {
                "clientId": id,
                "projectId": projects,
                "fromDate": fromDate,
                "toDate": toDate
            };
            service.Excelgenerate(obj, selectedClient.clientName, month)
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }, 1500);
    }

    //****************Month(First and last date)**************//

    const handleMonthChange = (e: any) => {
        if (e) {
            setSafariMonth(e)
            const selectedDate = moment(e);
            const firstDayOfMonth = selectedDate.startOf('month').format('YYYY-MM-DD');
            const lastDayOfMonth = selectedDate.endOf('month').format('YYYY-MM-DD');

            setFromDate(firstDayOfMonth);
            settoDate(lastDayOfMonth);

            const monthName = selectedDate.format('MMMM');
            setmonth(monthName);
        }
    };
    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Time Report – Client wise</h3>
                                </div>
                            </div>
                            <div style={{ marginTop: "3%" }} className="row filter-row">
                                <div className=" col-md-3 ">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Month & Year <span className="text-danger">*</span></label>
                                        <div>
                                            <div>
                                                {/* <IonInput type="month" onIonChange={handleMonthChange} className="form-control datetimepicker" /> */}
                                                <DatePicker clearIcon={null} maxDetail="year" format="MM/yyyy" value={safariMonth} className="form-control" onChange={handleMonthChange} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className=" col-md-3 ">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Client <span className="text-danger">*</span></label>
                                        <div>
                                            <div>
                                                <Select
                                                    options={options}
                                                    value={options.find((option) => option.value === selectedClientId) || null}
                                                    onChange={handleclient}
                                                    onInputChange={handleInputChange}
                                                    onMenuOpen={handleMenuOpen}
                                                    onMenuClose={handleMenuClose}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    menuIsOpen={menuIsOpen}
                                                    isSearchable
                                                    placeholder={<Placeholder />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator,
                                                    }}
                                                    className="custom-select7"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project Status </label>
                                        <Select
                                                options={options9}
                                                value={options9.find((option: any) => option.value === projectStatusId) || null}
                                                onChange={hanldeStatusTypes}
                                                onInputChange={handleInputChange9}
                                                onMenuOpen={handleMenuOpen9}
                                                onMenuClose={handleMenuClose9}
                                                onFocus={handleFocus9}
                                                onBlur={handleBlur9}
                                                menuIsOpen={menuIsOpen9}
                                                isSearchable
                                                // disabled={isEdit === true ? false : true}
                                                placeholder={<Placeholder9 />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicator9,
                                                }}
                                                className="custom-select0"
                                            />
                                    </div>
                                </div>

                                <div className="col-md-3" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                    <button onClick={() => { Cliproject() }} className="btn btn-orange btn-block w-100">
                                        Select Projects
                                    </button>
                                </div>
                                <div className="col-md-4 ExcelClientReport" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                    <button onClick={Export} className={`btn btn-success btn-block w-100 ${areCheckboxesSelected ? "" : "d-none"}`}><i className="la la-file-pdf-o" />
                                        <a style={{ fontSize: "13px" }}>Generate pdf (Project Wise)</a>
                                    </button>
                                </div>
                                <div className="col-md-4 ExcelClientReport" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                    <button onClick={PDF} className={`btn btn-success btn-block w-100 ${areCheckboxesSelected ? "" : "d-none"}`}><i className="la la-file-pdf-o" />
                                        <a style={{ fontSize: "13px" }}>
                                            Generate pdf (Employee Wise)
                                        </a>
                                    </button>
                                </div>
                                <div className="col-md-4 ExcelClientReport" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                    <button onClick={Excel} className={`btn btn-success btn-block w-100 ${areCheckboxesSelected ? "" : "d-none"}`}><i className="la la-file-excel-o" />
                                        <a style={{ fontSize: "13px" }}>
                                            Generate Excel
                                        </a>
                                    </button>
                                </div>
                            </div>
                            {isLoading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            {isSearchClicked && (
                                <div style={{ marginTop: '2%' }} className="table-responsive">
                                    {datatable.length > 0 ? (
                                        <DataTable
                                            className="table-responsive"
                                            columns={columns}
                                            data={datatable}
                                            pagination
                                            paginationPerPage={10}
                                            paginationComponentOptions={paginationComponentOptions}
                                            paginationRowsPerPageOptions={[10, 20, 30]}
                                            subHeader
                                            selectableRows
                                            onSelectedRowsChange={Projectidd}
                                            clearSelectedRows={!isFocused}
                                            subHeaderComponent={subHeaderComponent}
                                            customStyles={customStyles}
                                        />
                                    ) : (
                                        <DataTable
                                            className="table-responsive"
                                            columns={columns}
                                            data={datatable}
                                            pagination
                                            paginationPerPage={10}
                                            paginationComponentOptions={paginationComponentOptions}
                                            paginationRowsPerPageOptions={[10, 20, 30]}
                                            subHeader
                                            selectableRows
                                            onSelectedRowsChange={Projectidd}
                                            clearSelectedRows={!isFocused}
                                            subHeaderComponent={subHeaderComponent}
                                            customStyles={customStyles}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                        {/* asas */}
                    </div>
                    <div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default ClientReport